<div class="d-lg-block d-none">
  <fgb-banner [title]="'terms.text' | translate"></fgb-banner>
</div>

<div class="widget-mobile">
  <div class="container">
    <div class="terms-container">
      <fgbcl-terms-and-conditions [type]="termsAndConditionsType" [defaultTerms]="defaultTemplate"></fgbcl-terms-and-conditions>
    </div>
  </div>

  <ng-template #defaultTemplate> <fgb-loading></fgb-loading> </ng-template>
</div>
